<template>
    <crud-facecade
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        v-wechat-title="title"
        :tableHeight="tableHeight"
        :addButton="{ permission: 'menu:create' }"
        :deleteButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
    >
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `SurgeryInfoExtraParam`,
    props: {},
    data() {
        return {
            title: `手术扩展字段设置`,
            url: { baseURL: `/api/AcisSystem/SurgeryInfoExtraParam` },
            buttons: [],
            basicGroups: [{ label: `基本信息`, value: `基本信息` }, { label: `手术信息`, value: `手术信息` }, { label: `手术人员信息`, value: `手术人员信息` }]
        }
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    // width: "180",
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `show_name`,
                    label: `显示名称`,
                    width: `160`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `data_key`,
                    label: `CodeKey`,
                    width: `160`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `data_type`,
                    label: `字段类型`,
                    width: `150`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: this.datatypeoption || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `basic_group_name`,
                    label: `基准分组名称`,
                    width: `150`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    sortable: true,
                    options: this.basicGroups || []
                },
                {
                    type: `string`,
                    prop: `data_group_name`,
                    label: `分组名称`,
                    width: `150`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `data_option`,
                    label: `数据源`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `number`,
                    prop: `data_colspan`,
                    label: `宽度(24为4个字段)`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true
                }, {
                    type: `select`,
                    prop: `data_read_only`,
                    label: `是否只读`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: false
                },
                {
                    type: `select`,
                    prop: `is_creatable`,
                    label: `是否新增可见`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: true
                },
                {
                    type: `select`,
                    prop: `is_editable`,
                    label: `是否编辑可见`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: true
                }, {
                    type: `select`,
                    prop: `is_listable`,
                    label: `是否列表可见`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: true
                },
                {
                    type: `select`,
                    prop: `is_searchable`,
                    label: `是否可查询`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: false
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序号`,
                    width: `120`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `120`,
                    readonly: false,
                    fixed: `right`,
                    isListable: true,
                    options: [
                        {
                            class: `is-plain`,
                            label: `编辑`,
                            type: `primary`,
                            emit: `LoadingUpdateView`,
                            permission: `default` // user:assignRole
                        },
                        {
                            class: `is-plain`,
                            label: `删除`,
                            type: `danger`,
                            emit: `DeleteData`,
                            permission: `default` // user:assignRole
                        }
                    ]
                }
            ]
        },
        //
        datatypeoption() {
            return [{ label: `文本框`, value: `string` },
                { label: `下拉框`, value: `select` },
                { label: `下拉多选框(支持自定义输入)`, value: `multiselect` },
                { label: `远程搜索下拉框`, value: `remoteselect` },
                { label: `远程搜索复选框`, value: `remotemultiselect` },
                { label: `单选框`, value: `radio` },
                { label: `选择框`, value: `checkbox` },
                { label: `复选框`, value: `checkboxgroup` },
                { label: `日期时间`, value: `datetime` },
                { label: `日期`, value: `date` },
                { label: `文本域`, value: `textarea` }]
        }
    },
    mounted() {},
    methods: {}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SurgeryInfoExtraParam/SurgeryInfoExtraParam.vue